import React from 'react';
import './Pokerwatch_new.css';
class Suggestions extends React.Component {
    
    render() {
        if (!this.props.data || this.props.data.length === 0) {
            return '';
        }
        return <div className={this.props.elemClass}>
            {this.props.data.map((r, _id) => (
                <button key={_id} className="suggestions-button" onClick={e => this.props.actionPerform(e, r)}>{r.teamName !== undefined ? r.teamName : r.name||r._id}</button>
            ))}
        </div>
    }
}

export default Suggestions;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/Suggestions.js
 **/